import TextLink from 'LuxKit/TextLink'
import moment from 'moment'
import React from 'react'
import { NeverEndingSummerBackground } from './components/NeverEndingSummerBackground'
import { NeverEndingSummerLogo } from './components/NeverEndingSummerLogo'

const neverEndingSummerTakeoverConfig: App.SiteTakeoverConfig = {
  id: 'neverendingsummer',
  startDate: moment('2025-07-23T00:00:00+0000'), // UK Time
  endDate: moment('2025-08-06T23:59:00+0000'), // UK Time
  brands: new Set(['luxuryescapes']),
  regions: {
    type: 'inclusive',
    list: new Set(['GB', 'FR', 'IT', 'ES', 'NL', 'DE', 'IE']),
  },
  verticals: new Set(['home']),
  palette: 'default',
  primaryColour: '',
  backgroundElement: NeverEndingSummerBackground,
  heroSection: {
    title: 'Never-ending Summer',
    subtitle: <>Last-minute getaways. Escape while offers last! <TextLink wrap="no-wrap" to="/campaign/neverendingsummer">View all offers</TextLink></>,
    logo: <NeverEndingSummerLogo />,
    filters: [],
    palette: 'default',
    verticals: new Set(['home']),
  },
}

export default neverEndingSummerTakeoverConfig
